import {
    ChangeDetectorRef,
    Component,
    ElementRef,
    EventEmitter,
    Input,
    OnChanges,
    OnDestroy,
    OnInit,
    Output,
    SimpleChanges,
    ViewChild,
} from '@angular/core';
import { AlarmAnimationService } from '@service/alarm-animation.service';
import { DeviceFlagsService } from '@service/device-flags.service';
import { ResponsiveService } from '@service/responsive.service';

import { Channel, ChannelFns, FlagOption } from 'ops/common/models/channel';
import { Subscription } from 'rxjs';

@Component({
    selector: 'app-channel-table-row',
    templateUrl: './channel-table-row.component.html',
    styleUrls: [
        '../channel-table-header/channel-table-header.component.scss',
        './channel-table-row.component.scss',
    ],
    standalone: false,
})
export class ChannelTableRowComponent implements OnChanges, OnInit, OnDestroy {
    @Input() channel: Channel;
    @Input() isSelectedChannel: boolean;

    @Output() onInitScroll = new EventEmitter<HTMLElement>();

    flagsSubscription: Subscription;

    @ViewChild('channelWrap', { static: true })
    channelWrap: ElementRef;
    disabled: boolean = false;

    channelValue: number;
    isDigital: boolean;
    measurementUnit: string;

    currentFlag: FlagOption = FlagOption.UNDEFINED;

    statusString: string = '';
    status: FlagOption = FlagOption.UNDEFINED;

    ngClass;

    constructor(
        public flagService: DeviceFlagsService,
        public alarmAnimation: AlarmAnimationService,
        public responsive: ResponsiveService,
        public cdr: ChangeDetectorRef,
    ) {}

    ngOnInit(): void {
        this.disabled = ChannelFns.isChannelBlank(this.channel);
        this.isDigital = ChannelFns.isDigital(this.channel);
        this.measurementUnit = this.channel.opsData.measurementUnit;
        this.flagsSubscription = this.flagService.onAllFlagsUpdated().subscribe(() => {
            this.channelValue = this.flagService.getFlags(this.channel)?.value;
            this.ngClass = this.alarmAnimation.getAlarmClasses(this.channel);
            this.updateStatusString();
            this.cdr.markForCheck();
        });
    }

    ngOnChanges(changes: SimpleChanges) {
        if (changes.isSelectedChannel && this.isSelectedChannel && this.channelWrap) {
            this.onInitScroll.emit(this.channelWrap.nativeElement);
        }
    }

    ngOnDestroy(): void {
        this.flagsSubscription?.unsubscribe();
    }

    getValueString() {
        return this.formatValue(this.channelValue);
    }

    updateStatusString() {
        this.status = this.flagService.getStatus(this.channel);
        this.statusString = ChannelFns.getStatusString(this.status);
    }

    formatValue(value) {
        return ChannelFns.transformValue(this.channel, value);
    }
}
